export function setCookie(
    name: string,
    value: string,
    daysToLive?: number,
): void {
    document.cookie = `${name}=${encodeURIComponent(value)}${
        daysToLive !== undefined
            ? `; max-age=${Math.floor(daysToLive * 24 * 3600)}`
            : ''
    }`;
}

export function getCookie(name: string): string | null {
    if (document?.cookie) {
        const cookies: { [key: string]: string } = document.cookie
            .split(';')
            .reduce((acc, pair) => {
                const [key, value] = pair.split(/=/);
                return {
                    ...acc,
                    [key.trim()]: value,
                };
            }, {});

        if (cookies[name] === undefined) {
            return null;
        }

        return decodeURIComponent(cookies[name]);
    }

    return null;
}
